const translations = {
  fr: {
    salesMembers: {
      allSalesMembers: 'Tous les vendeurs',
    },
  },

  en: {
    salesMembers: {
      allSalesMembers: 'Entire Sales Team',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesMembers/i18n/salesMembers.js